/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GenerateTransformFunctionResponse = core.serialization.object({
    transformFunction: core.serialization.string(),
    transformFunctionPrompt: core.serialization.string(),
});
